import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { ConfirmDeactivateGuard } from "src/commons/guards";
import { CommunityGrantRouter } from "./community-grant.router";
import { reducers } from "./state/community-grant.selectors";


@NgModule({
    imports: [
        CommunityGrantRouter,
        StoreModule.forFeature('communityGrant', reducers),
    ],
    providers: [ConfirmDeactivateGuard],
    declarations: []
})
export class CommunityGrantScreenModule { }